import { render, staticRenderFns } from "./WindowBrokenWindow.vue?vue&type=template&id=5fcb4b96&scoped=true"
import script from "./WindowBrokenWindow.vue?vue&type=script&lang=ts"
export * from "./WindowBrokenWindow.vue?vue&type=script&lang=ts"
import style0 from "./WindowBrokenWindow.vue?vue&type=style&index=0&id=5fcb4b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb4b96",
  null
  
)

export default component.exports